import React, { useCallback, useMemo, useState } from 'react'

import ExplanationButton from '@components/Button/ExplanationButton/ExplanationButton'
import { Explanation, getExplanation } from '@lib/query/queryFunction'
import AlertModal from '@components/Modal/AlertModal'

type ExplanationButtonContainerProps = {
  explanationId: number
}

const ExplanationButtonContainer: React.FC<ExplanationButtonContainerProps> = ({
  explanationId,
}) => {
  const [showExplanationModal, setShowExplanationModal] = useState(false)
  const [explanationInformation, setExplanationInformation] = useState<Explanation>()
  const explanationButtonCallback = useCallback(async () => {
    const explanation = await getExplanation(explanationId)()
    setExplanationInformation(explanation)
    setShowExplanationModal(true)
  }, [explanationId])

  const modalData = useMemo(() => {
    return {
      title: '문제 해설',
      body: (
        <div className="">
          <p
            className={'text-left mt-4'}
          >{`표준교재 ${explanationInformation?.standardTextPage}P`}</p>
          <p className={'text-left mt-4 mb-6 text-base font-normal whitespace-pre-wrap'}>
            {explanationInformation?.text}
          </p>
        </div>
      ),
    }
  }, [explanationInformation])

  return (
    <div>
      <AlertModal
        show={showExplanationModal}
        setShow={setShowExplanationModal}
        data={modalData}
        className="relative !overflow-visible"
      ></AlertModal>
      <ExplanationButton onClick={explanationButtonCallback} />
    </div>
  )
}

export default ExplanationButtonContainer
